import { Navbar, NavbarBrand, Button } from "reactstrap";
import { useLocation } from "react-router-dom";
import EALogo from "./EALogo";
import { useAuth } from "../context/AuthContext";

const ERROR_MESSAGES: Record<string, string> = {
  SE1: "No valid Subscription.",
  SE2: "Subscription expired.",
};

const Unauthorised = () => {
  const { REACT_APP_THEME } = process.env;
  const { logout } = useAuth();
  const location = useLocation();
  const errorCode = (location.state as { errorCode?: string } | null)?.errorCode;
  const errorMessage =
    errorCode && Object.prototype.hasOwnProperty.call(ERROR_MESSAGES, errorCode)
      ? ERROR_MESSAGES[errorCode]
      : undefined;

  return (
    <>
      <div role="alert" className="text-center">
        <Navbar
          color={REACT_APP_THEME}
          className="navbar-dark bd-navbar"
          expand="lg"
          fixed="top"
          id="ea_navbar"
        >
          <NavbarBrand tag="div" className="d-flex justify-content-start bg-visnet">
            <EALogo
              theme={REACT_APP_THEME}
              displayName={""}
              color="#fff"
              logoColor="#fff"
              logoBgColor="#fab274"
            />
          </NavbarBrand>
        </Navbar>

        <h1 className="pt-3">Unauthorised</h1>
        <pre className="text-danger" style={{ fontSize: "1rem" }}>
          Unfortunately you do not have access to this page, please contact your administrator.
        </pre>
        {errorMessage && (
          <pre className="text-danger" style={{ fontSize: "1rem" }}>
            {errorMessage}
          </pre>
        )}
        <Button color="btn btn-primary btn-sm" onClick={logout}>
          Login
        </Button>
      </div>
    </>
  );
};

export default Unauthorised;
